import { SettingConst } from '@faire/web-api--source/types';

/**
 * Optimize the loading of brand review data on the PDP.
 */
export const BRAND_REVIEW_PDP_API_SPLIT_250227 =
  'BRAND_REVIEW_PDP_API_SPLIT_250227' as SettingConst<
    'BRAND_REVIEW_PDP_API_SPLIT_250227',
    boolean,
    'RETAILER' | 'VISITOR_WEB' | 'RETAILER_ANDROID'
  >;
